
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('section#shopify-section-template--24313027559730__main');
    if (section) {
      const textNodes = Array.from(section.childNodes).filter(
        (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '1'
      );
      textNodes.forEach((node) => node.remove());
    }
  });
